module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "worker_form"
  }, [_c('div', [_vm._v(_vm._s(_vm.model.user_first_name) + " " + _vm._s(_vm.model.user_last_name))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field012"
    }
  }, [_vm._v("Пользователь")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.user_id),
      expression: "model.user_id"
    }],
    attrs: {
      "id": "field012"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field022"
    }
  }, [_vm._v("Клиника")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.clinic_id),
      expression: "model.clinic_id"
    }],
    attrs: {
      "id": "field022"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "clinic_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.clinics), function(clinic) {
    return _c('option', {
      domProps: {
        "value": clinic._id
      }
    }, [_vm._v(_vm._s(clinic.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field02"
    }
  }, [_vm._v("Роль")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.role_id),
      expression: "model.role_id"
    }],
    attrs: {
      "id": "field02"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "value": role._id
      }
    }, [_vm._v(_vm._s(role.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field01"
    }
  }, [_vm._v("Должность")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.position),
      expression: "model.position"
    }],
    attrs: {
      "type": "text",
      "id": "field01"
    },
    domProps: {
      "value": (_vm.model.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "position", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field03"
    }
  }, [_vm._v("Принимает?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.can),
      expression: "model.can"
    }],
    attrs: {
      "id": "field03"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "can", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Да")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("Нет")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "by_request"
    }
  }, [_vm._v("По заявкам")])])]), _vm._v(" "), _c('div', {
    staticClass: "field check_field"
  }, [_c('label', [_vm._v("Тип")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.type),
      expression: "model.type"
    }],
    staticClass: "type_check",
    attrs: {
      "type": "checkbox",
      "value": "adult"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.type) ? _vm._i(_vm.model.type, "adult") > -1 : (_vm.model.type)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.type,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "adult",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.type = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model.type = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.model, "type", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "forCheck"
  }, [_vm._v("Взрослый")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.type),
      expression: "model.type"
    }],
    staticClass: "type_check",
    attrs: {
      "type": "checkbox",
      "value": "childish"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.type) ? _vm._i(_vm.model.type, "childish") > -1 : (_vm.model.type)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.type,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "childish",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.type = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model.type = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.model, "type", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "forCheck"
  }, [_vm._v("Детский")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field05"
    }
  }, [_vm._v("Статус")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.status),
      expression: "model.status"
    }],
    attrs: {
      "id": "field05"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "created"
    }
  }, [_vm._v("Создан")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "blocked"
    }
  }, [_vm._v("Заблокирован")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field06"
    }
  }, [_vm._v("Время")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.time),
      expression: "model.time"
    }],
    attrs: {
      "type": "number",
      "id": "field06"
    },
    domProps: {
      "value": (_vm.model.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "time", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48bf7b60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin panel/forms/WorkerForm.vue
// module id = 611
// module chunks = 0